;
const AI_PLATFORM_POSTMASTER_ENDPOINT = 'postmaster@aiplatform.msging.net';
export class AiApplicationService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async processCommand(command) {
        const resourceRequest = {
            method: command.method,
            type: command.type,
            to: AI_PLATFORM_POSTMASTER_ENDPOINT,
            uri: command.uri
        };
        if (command.resource) {
            Object.assign(resourceRequest, { resource: command.resource });
        }
        try {
            const response = await this.MessagingHubService.processCommand(resourceRequest);
            return response ?? null;
        }
        catch (error) {
            console.error('Error processing AI Application command:', error);
            return null;
        }
    }
    async processCommandOrThrow(command, errorMsg) {
        const resource = await this.processCommand(command);
        // CRITICAL: Differentiate between network error (resource is null) and command error (resource.resource is falsy)
        if (!resource) {
            throw new Error(`Network error: failed to reach AI platform service for uri=${command.uri}`);
        }
        if (!resource.resource) {
            throw new Error(errorMsg ?? `AiApplicationService: command returned status=${resource.status} for uri=${command.uri}`);
        }
        return resource.resource;
    }
}
AiApplicationService.$inject = ['MessagingHubService'];
